/**
 * 管理模块
 */
import { PAGE_LEVEL } from '@/constants';

export default {
  meta: {
    localeModules: [
      'profile',
      'management',
      'systemSetting',
      'contacts',
      'member',
      'statistics',
      'publicOpinion',
      'aiDataUsage',
      'mcpKey',
      'roadshow'
    ]
  },
  path: '/systemSetting',
  redirect: '/systemSetting/profile',
  children: [
    {
      // 个人中心
      path: 'profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: 'profile' */ '@/pages/systemSetting/userProfile/index.vue'),
      meta: {
        name: 'routers.manage_personal_center',
        componentName: 'UserProfile',
        keepAlive: true,
        // electron 环境下 单独tab
        electronSingle: true
      }
    },
    {
      // 成员管理
      path: 'memberManage',
      name: 'memberManage',
      component: () => import(/* webpackChunkName: 'member-manage' */ '@/pages/systemSetting/memberManage/index.vue'),
      meta: {
        name: 'routers.manage_member_manage',
        componentName: 'MemberManageIndex',
        keepAlive: true,
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    {
      //  机构设置
      path: 'organizationSetting',
      name: 'organizationSetting',
      component: () =>
        import(/* webpackChunkName: 'organization-setting' */ '@/pages/systemSetting/organizationSetting/index.vue'),
      meta: {
        name: 'routers.manage_organization_setting',
        componentName: 'OrganizationSettingIndex',
        keepAlive: true,
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    // 会员权益
    {
      path: 'memberRights/list',
      name: 'memberRights',
      component: () => import(/* webpackChunkName: 'member-rights' */ '@/pages/systemSetting/memberRights/index'),
      meta: {
        componentName: 'MemberRightsListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        name: 'routers.manage_member_rights'
      }
    },
    {
      // 查看会员激活码
      path: 'memberRights/activationCode',
      name: 'activationCode',
      component: () =>
        import(
          /* webpackChunkName: 'member-rights-activation-code' */ '@/pages/systemSetting/memberRights/activationCode'
        ),
      meta: {
        name: 'routers.manage_view_member_activation_code',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/systemSetting/memberRights/list'
      }
    },
    {
      // 合作券商
      path: 'cooperateBrokerage/list',
      name: 'cooperateBrokerage',
      component: () =>
        import(/* webpackChunkName: 'cooperate-brokerage' */ '@/pages/systemSetting/cooperateBrokerage/index'),
      meta: {
        componentName: 'CooperateBrokerageListIndex',
        name: 'routers.manage_cooperate_brokerage',
        keepAlive: true,
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    {
      // 数据统计
      path: '/statistics/list',
      component: () => import(/* webpackChunkName: 'data-statistics' */ '@/pages/statistics/roadshow/index.vue'),
      meta: {
        componentName: 'RoadshowStatisticsIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        name: 'routers.manage_data_statistics'
      }
    },
    {
      // AI 数据用量看板
      path: '/statistics/aiUsage',
      name: 'aiUsageDashboard',
      component: () => import(/* webpackChunkName: 'ai-usage-dashboard' */ '@/pages/statistics/aiUsage/index.vue'),
      meta: {
        componentName: 'AiUsageDashboard',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        name: 'routers.manage_ai_usage_dashboard'
      }
    },
    {
      path: '/statistics/employee/detail',
      name: 'employeeStatisticsDetail',
      component: () =>
        import(/* webpackChunkName: 'employee-statistics-detail' */ '@/pages/statistics/employee/detail.vue'),
      meta: {
        parent: '/statistics/list',
        name: 'routers.manage_employee_behavior_details',
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      // 会议推送配置
      path: '/systemSetting/meetingPush/config',
      component: () => import('@/pages/systemSetting/meetingPush/index.vue'),
      meta: {
        componentName: 'RoadshowStatisticsIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.manage_meeting_push_config'
      }
    },
    {
      // 成员推送
      path: '/contact/sync',
      name: 'maillistPush',
      component: () => import(/* webpackChunkName: 'manage-contact' */ '@/pages/systemSetting/maillistPush/index.vue'),
      meta: {
        componentName: 'RoadshowStatisticsIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.manage_member_push'
      }
    },
    {
      // 会议账号绑定
      path: '/meeting-account/binding',
      component: () =>
        import(/* webpackChunkName: 'manage-meeting-account' */ '@/pages/systemSetting/meetingAccountBind/index.vue'),
      meta: {
        componentName: 'MeetingAccountBind',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.manage_meeting_authorization'
      }
    },
    {
      // 舆情管理
      path: 'publicOpinionManage',
      name: 'publicOpinionManage',
      component: () =>
        import(/* webpackChunkName: 'public-opinion-manage' */ '@/pages/systemSetting/publicOpinionManage/index.vue'),
      meta: {
        name: 'routers.manage_public_opinion_manage',
        componentName: 'PublicOpinionManageIndex',
        keepAlive: true,
        pageLevel: PAGE_LEVEL.FIRST
      }
    }
  ]
};
